class ProductATC extends HTMLElement {
  constructor() {
    super();

    // Header
    this.header = document.querySelector('.site-header');
    this.headerHeight = this.header.clientHeight;

    // USP bar
    this.uspBar = document.querySelector('.usp-bar');
    this.uspBarHeight = this.uspBar.clientHeight;

    // Buy button
    this.buyButton = document.querySelector('[data-static-buy-button]').parentNode;
    this.buyButtonHeight = this.buyButton.clientHeight;

    this.debouncedOnLoad = debounce((event) => {
      // when bottom is reached, hide the bar. Use math because it can return a half pixel...
      if (
        event.type === 'scroll' &&
        window.innerHeight + Math.round(window.scrollY) >= document.body.offsetHeight
      ) {
        this.removeActiveClassToBody();
        return;
      }
      this.showBar();
    }, 50);

    ['load', 'scroll'].forEach((eventListener) => {
      window.addEventListener(eventListener, this.debouncedOnLoad.bind(this));
    });
  }

  /**
   * Show bar
   */
  showBar() {
    // register IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const { bottom } = entry.boundingClientRect;

        // Set offset top to .5% of the buy button
        let offsetTop = this.buyButtonHeight / 1.5;

        offsetTop += this.headerHeight ? this.headerHeight : 0;
        offsetTop += this.uspBarHeight ? this.uspBarHeight : 0;

        // Check if bottom bar is visible
        const isBottomVisible = bottom <= offsetTop;

        // display the bar when the ATC button is almost out of screen
        isBottomVisible ? this.addActiveClassToBody() : this.removeActiveClassToBody();
      });
    });
    // declares what to observe, and observes its properties.
    observer.observe(this.buyButton);
  }

  /**
   * Add active class to the body
   */
  addActiveClassToBody() {
    document.body.classList.add('sticky-atc--active');
  }

  /**
   * Remove active class to the body
   */
  removeActiveClassToBody() {
    document.body.classList.remove('sticky-atc--active');
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', ProductATC);
}
